import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { PureComponent } from 'react';
import Box, { splitBoxProps } from 'ui-box';
import { Icon } from '../../icon';
import { TextInput } from '../../text-input';
import { withTheme } from '../../theme';
import { StackingOrder } from '../../constants';

var SearchInput =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SearchInput, _PureComponent);

  function SearchInput() {
    _classCallCheck(this, SearchInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(SearchInput).apply(this, arguments));
  }

  _createClass(SearchInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          appearance = _this$props.appearance,
          disabled = _this$props.disabled,
          height = _this$props.height,
          props = _objectWithoutProperties(_this$props, ["theme", "appearance", "disabled", "height"]);

      var _splitBoxProps = splitBoxProps(props),
          matchedProps = _splitBoxProps.matchedProps,
          remainingProps = _splitBoxProps.remainingProps;

      var width = matchedProps.width;
      var iconSize = theme.getIconSizeForInput(height);
      return React.createElement(Box, _extends({
        position: "relative",
        display: "inline-flex",
        height: height
      }, matchedProps), React.createElement(Box, {
        height: height,
        width: height,
        pointerEvents: "none",
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }, React.createElement(Icon, {
        icon: "search",
        color: "default",
        zIndex: StackingOrder.FOCUSED + 1,
        size: iconSize
      })), React.createElement(TextInput, _extends({
        height: height,
        paddingLeft: height,
        appearance: appearance,
        disabled: disabled,
        width: width,
        type: "search"
      }, remainingProps)));
    }
  }]);

  return SearchInput;
}(PureComponent);

SearchInput.displayName = "SearchInput";

_defineProperty(SearchInput, "propTypes", _objectSpread({}, TextInput.propTypes));

_defineProperty(SearchInput, "defaultProps", {
  height: 32,
  appearance: 'default'
});

export default withTheme(SearchInput);